import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { TLinkDisciplineTechCategory } from '../types/types';

const initialState:
    {
        LinkDisciplineTechCategory: TLinkDisciplineTechCategory[]

    } = {
    LinkDisciplineTechCategory: []
}

const LinkDisciplineTechCategory = createSlice({
    name: 'linkDisciplineTechCategory',
    initialState,
    reducers: {
        addLinkDisciplineTechCategory: (state, action: PayloadAction<TLinkDisciplineTechCategory[]>) => {
            state.LinkDisciplineTechCategory = action.payload
        },
    },
});

export const { addLinkDisciplineTechCategory } = LinkDisciplineTechCategory.actions;

export default LinkDisciplineTechCategory.reducer;